<template>
  <div class="space-y-6">
    <!-- <div class="space-y-2">
      <h2 class="text-background-fg/87 text-lg font-medium">
        Today's Summary
      </h2>
      <MerchantGroupDashboardReportSummary
        v-if="showSalesSummary"
        :query="salesSummaryQuery"
        label="Sales"
      />
      <MerchantGroupDashboardReportSummary
        v-if="showDonationsSummary"
        :query="donationsSummaryQuery"
        label="Donations"
      />
    </div> -->
    <!-- <div class="grid grid-cols-1 gap-2 lg:grid-cols-2">
      <div class="flex flex-col">
        <h2
          class="text-background-fg/87 mb-2 flex-shrink-0 text-lg font-medium"
        >
          Revenue
        </h2>

        <BaseCard class="relative h-full">
          <MerchantGroupDashboardTransactionChart />
        </BaseCard>
      </div>

      <div class="flex flex-col">
        <h2
          class="text-background-fg/87 mb-2 flex-shrink-0 text-lg font-medium"
        >
          Latest Transactions
        </h2>
        <BaseCard class="relative h-full">
          <MerchantGroupDashboardTransactionsList />
        </BaseCard>
      </div>
    </div> -->
    <div class="flex flex-col">
      <div class="mb-2 flex items-baseline justify-end">
        <!-- <h2
          class="text-background-fg/87 text-lg font-medium"
        >
          Merchants
        </h2> -->
        <span
          v-if="merchantStatsLastRefreshed"
          class="relative top-1 text-xs text-black/40"
        >
          Merchant stats last refreshed at
          {{ merchantStatsLastRefreshed }}
        </span>
      </div>
      <BaseCard>
        <MerchantGroupMerchantsTable
          :merchants="merchants"
          :is-loading="merchantsLoading"
        />
      </BaseCard>
    </div>
  </div>
</template>

<script setup lang="ts">
import * as DateFns from "date-fns"

// import MerchantGroupDashboardTransactionsList from "@/components/merchantGroup/MerchantGroupDashboardTransactionsList.vue"
// import type { MerchantGroupSummaryReportQuery } from "@/services/merchantGroup/reports/retrieveMerchantGroupSummaryReport"
import { useMerchantGroupMerchants } from "@/services/merchantGroup/listMerchantGroupMerchants"

// const today = DateFns.format(new Date(), "yyyy-MM-dd")

// const salesSummaryQuery: MerchantGroupSummaryReportQuery = {
//   start: today,
//   end: today,
//   sources: ["sale"],
// }

// const donationsSummaryQuery: MerchantGroupSummaryReportQuery =
//   {
//     start: today,
//     end: today,
//     sources: ["donation"],
//   }

const { data: merchantResp, isLoading: merchantsLoading } =
  useMerchantGroupMerchants()

const merchants = computed(
  () => merchantResp.value?.merchants ?? []
)

const merchantStatsLastRefreshed = computed(() =>
  merchantResp.value?.lastRefreshed
    ? DateFns.format(
        merchantResp.value.lastRefreshed,
        "HH:mm dd/MM/yyyy"
      )
    : ""
)

// const showSalesSummary = computed(() =>
//   merchants.value.some((m) => m.hasSalesModule)
// )

// const showDonationsSummary = computed(() =>
//   merchants.value.some((m) => m.hasDonationsModule)
// )
</script>
